import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineClientDetailView のスタイル
 */
export const hotlineClientDetailViewStyle = tv({
    slots: {
        base: ['py-24 px-16 lg:p-32', 'md:rounded-md'],
    },
});
